// SPV Pool v1.0 PR 6 — Section A. One headline number: total inflows for
// the selected period, with a secondary line counting the contributing
// loans.

import { Card } from "@/design-system/components/ui";
import { formatCurrency } from "../../../shared/format";
import type { CashFlowInflowsDto } from "@/types/spvPool";

interface InflowsCardProps {
  inflows: CashFlowInflowsDto;
}

export function InflowsCard({ inflows }: InflowsCardProps) {
  return (
    <Card>
      <div className="text-label font-display uppercase tracking-label text-gold-shadow mb-space-1">
        Inflows for period
      </div>
      <div className="font-display font-bold text-h1 text-onyx leading-tight">
        {formatCurrency(inflows.totalInflows)}
      </div>
      <p className="text-small text-gray-mid m-0 mt-space-1">
        From {inflows.loanCount} loan{inflows.loanCount === 1 ? "" : "s"} with
        segments in this pool
      </p>
    </Card>
  );
}
